export default {
    ADD_ROW:'ADD_ROW',
    VALIDATE_FORM:'VALIDATE_FORM',
    ADD_ROW_TO_FORM:'ADD_ROW_TO_FORM',
    FILL_ROW:'FILL_ROW',
    UPDATE_ROW_DATA:'UPDATE_ROW_DATA',
    REMOVE_ROW:'REMOVE_ROW',
    SET_FIELD_ERROR:'SET_FIELD_ERROR',
}
